import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { formatTime } from '../../utils/time.utils'
import useAdminApi from '../../API/admin.api'
import * as authSelectors from '../../redux/selectors/auth.selectors'
import * as icons from '../source/Icons.source'

import styles from '../../styles/components/admin/payment.module.css'
import usePaymentApi from '../../API/payment.api'


function Payment({payment, refresh=()=>{}}) {
    const access = useSelector(authSelectors.adminAccess)
    const forseAccess = (access === 'ADMIN')

    const adminApi = useAdminApi()
    const paymentApi = usePaymentApi()

    const [isWait, setIsWait] = useState(false)
    
    const [isOpenForse, setIsOpenForse] = useState(false)
    const [isOpenForseWait, setIsOpenForseWait] = useState(false)

    const [isOpenConfirm, setIsOpenConfirm] = useState(false)
    const [isOpenReject, setIsOpenReject] = useState(false)

    const forseHandler = async () => {
        if(!isOpenForse) { return setIsOpenForse(true) }

        const status = payment.status === 'CONFIRM'? 'REJECT' : 'CONFIRM'
        const res = await adminApi.forsePayment(payment._id, status)
        if(res) { refresh() }

        setIsOpenForse(false)
    }

    const forseWaitHandler = async () => {
        if(!isOpenForseWait) { return setIsOpenForseWait(true) }

        const res = await adminApi.forsePaymentWait(payment._id)
        if(res) { refresh() }

        setIsOpenForseWait(false)
    }

    const confirm = async () => {
        if(!isOpenConfirm) { return setIsOpenConfirm(true) }
        setIsWait(true)

        await adminApi.confirmPayment(payment._id)

        refresh(() => setIsWait(false))
        setIsOpenConfirm(false)
    }

    const reject = async () => {
        if(!isOpenReject) { return setIsOpenReject(true) }
        setIsWait(true)

        await adminApi.rejectPayment(payment._id) 
        
        refresh(() => setIsWait(false))
        setIsOpenReject(false)
    }

    const sendCallback = async () => {
        await paymentApi.sendCallback(payment._id)
    }

    return (
        <div className={styles.main}>
            <div>{payment?.amount} ₴</div>
            <div className={styles.iban}>
                <div>{payment?.card}</div>
                <div>{payment?.iban?.number}</div>
                <div>{payment?.iban?.INN}</div>
                <div>{payment?.iban?.number && (payment?.iban?.target || 'dafault')}</div>
            </div>
            
            <div>
                {payment?.workerName || payment?.worker} 
                {!!payment?.ncApiStatus && <span>({payment?.ncApiStatus || ''})</span>}
            </div>
            <div>{payment?.partnerName || payment?.partner}</div>
            <div>{payment?._id}</div>
            <div className={`${styles.status} ${payment?.status}`}>{payment?.status}</div>
            <div>
                {forseAccess && payment?.status !== 'WAIT' &&
                    <button className={styles.button} onClick={() => forseHandler()}>
                        forse
                    </button>
                }
                {forseAccess && payment?.status !== 'WAIT' &&
                    <button className={styles.button} onClick={() => forseWaitHandler()}>
                        {isOpenForseWait? 'sure?' : 'wait'}
                    </button>
                }
                {payment?.status === 'WAIT' && !isWait && forseAccess && <>
                    <button className={`${styles.button} ${styles.forse_button}`} onClick={() => confirm()}>
                        {icons.check}
                    </button>
                    <button className={`${styles.button} ${styles.forse_button}`} onClick={() => reject()}>
                        {icons.dismis}
                    </button>
                </>}
                {(payment?.status === 'CONFIRM' || payment?.status === 'REJECT') && <>
                    <button className={`${styles.button}`} onClick={() => sendCallback()}>
                        Clb
                    </button>
                </>}
            </div>
            <div className={styles.date}>
                {formatTime(payment?.createdAt).replaceAll(',', " ")}
            </div>
        </div>
      )
}

export default Payment